import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
interface IProps {
  color?: string;
  size?: number;
}
const TickIcon = (props: IProps) => (
  <Svg
    width={props.size ?? 18}
    height={props.size ?? 18}
    viewBox="0 0 18 18"
    fill="none"
  >
    <Path
      d="M9 1.5c1.005 0 1.957.195 2.827.555L10.65 3.232a6 6 0 104.342 6.076L16.5 9A7.5 7.5 0 119 1.5zm6.75 3L8.25 12 4.875 8.625 5.933 7.56 8.25 9.878l6.442-6.443L15.75 4.5z"
      fill={props.color ?? '#111111'}
    />
  </Svg>
);
export default TickIcon;
